import React from "react";
import { Button, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import TitleTooltip from "../Tooltip/TitleTooltip";

const useStyles = makeStyles(() => ({
  excelContainer: {
    display: "flex",
    alignItems: "center",
  },
  exportToExcelonTab: {
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px black",
    minWidth: "auto !important",
    marginLeft: "8px",
  },
}));

const ExportToExcelButton = ({
  onClick,
  title = "Export to Excel",
  imageSrc,
  placement = "bottom",
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.excelContainer}>
      <TitleTooltip title={title} placement={placement}>
        <Button
          size="small"
          className={classes.exportToExcelonTab}
          onClick={onClick}
        >
          <img
            alt="excel icon"
            src={imageSrc}
            style={{
              width: "4vw",
              height: "4vw",
              maxWidth: "20px",
              maxHeight: "20px",
            }}
          />
        </Button>
      </TitleTooltip>
    </Box>
  );
};

export default ExportToExcelButton;
